<template>
  <div class="purchase-item" :class="isCollapsedClass">
    <div class="purchase-item__header">
      <div class="header-lot-info-container">
        <button
          class="collapse-button"
          :class="{ collapsed: isCollapsed }"
          @click="toggleCollapse"
        >
          <ArrowIcon />
        </button>

        <span class="purchase-number">
          Закупка №{{ purchase.proposalNumber }}
        </span>

        <input
          v-if="isEditName"
          v-model="editedName"
          class="new-purchase-name-input"
          type="text"
          ref="nameInput"
          v-click-outside="endEditName"
          @click.stop
        />

        <span v-else class="purchase-name">
          {{ titleOverrides[purchase.proposalNumber] || purchase.proposalName }}
        </span>
      </div>
      <button class="header-change-name-button" @click.stop="toggleEditName">
        <PenIcon />
        {{ isEditName ? "Сохранить" : "Изменить название" }}
      </button>
    </div>

    <transition name="collapse" @enter="enter" @leave="leave">
      <div v-if="!isCollapsed" class="purchase-item__lots" ref="lots">
        <BitrixExportLotItem
          v-for="lot in purchase.lots"
          :key="lot.lotId"
          :lot="lot"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import BitrixExportLotItem from "./BitrixExportLotItem.vue";
import ArrowIcon from "@/assets/icons/table-collapse.svg";
import PenIcon from "@/assets/icons/pen-icon.svg";

export default {
  name: "BitrixExportPurchaseItem",
  components: {
    BitrixExportLotItem,
    ArrowIcon,
    PenIcon,
  },
  props: {
    purchase: {
      type: Object,
      required: true,
    },
    overridePurchaseName: {
      type: Function,
      required: true,
    },
    titleOverrides: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isCollapsed: false,
      isEditName: false,
      editedName: this.purchase.proposalName,
    };
  },
  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    startEditName() {
      this.isEditName = true;
      this.$nextTick(() => {
        this.$refs.nameInput.focus();
      });
    },

    endEditName() {
      this.isEditName = false;
      this.overridePurchaseName(this.purchase.proposalNumber, this.editedName);
    },

    toggleEditName() {
      if (!this.isEditName) this.startEditName();
      else this.endEditName();
    },
    enter(el) {
      el.style.height = 0;

      el.style.opacity = 0;

      el.style.overflow = "hidden";

      const height = el.scrollHeight;

      requestAnimationFrame(() => {
        el.style.transition = "height 0.35s ease, opacity 0.25s ease";

        el.style.height = height + "px";

        el.style.opacity = 1;
      });
    },

    leave(el) {
      el.style.height = el.scrollHeight + "px";

      el.style.opacity = 1;

      el.style.overflow = "hidden";

      requestAnimationFrame(() => {
        el.style.transition = "height 0.35s ease, opacity 0.25s ease";

        el.style.height = 0;

        el.style.opacity = 0;
      });
    },
  },
  computed: {
    isCollapsedClass() {
      return this.isCollapsed ? "collapsed" : "";
    },
  },
};
</script>

<style lang="less" scoped>
.purchase-item {
  border-radius: 8px;
  border: 2px solid #cfd8dd;
  transition: 0.3s ease border-radius;
  .purchase-item__header {
    background-color: #cfd8dd;
    display: flex;
    gap: 16px;
    .header-lot-info-container {
      height: 100%;
      width: 100%;
      display: grid;
      row-gap: 4px;
      column-gap: 8px;
      grid-template-areas:
        "arrow number"
        "arrow name";
      grid-template-columns: min-content 1fr;
      grid-template-rows: min-content 1fr;
      .collapse-button {
        grid-area: arrow;
        width: 40px;
        height: 100%;
        border-bottom: 2px solid #cfd8dd;
        border-top-left-radius: 6px;
        display: flex;
        justify-content: center;
        padding-top: 16px;
        &:hover {
          background-color: #fff;
        }
        svg {
          transition: 0.3s ease transform;
        }
      }
      .purchase-number {
        grid-area: number;
        text-align: left;
        font-family: Roboto;
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        margin-top: 18px;
      }
      .purchase-name {
        grid-area: name;
        text-align: left;
        font-family: Roboto;
        font-weight: 500;
        font-size: 20px;
        padding-bottom: 10px;
      }
      .new-purchase-name-input {
        grid-area: name;
        text-align: left;
        font-family: Roboto;
        font-weight: 500;
        font-size: 20px;
        height: 30px;
        margin-bottom: 10px;

        border: none;
        outline: none;
        box-shadow: none;
        // background: transparent;

        &:focus,
        &:active,
        &:hover {
          border: none;
          outline: none;
          box-shadow: none;
        }
      }
    }
    .header-change-name-button {
      height: 40px;
      width: 170px;
      min-width: 170px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;
      font-family: Roboto;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #7d919b;
      margin-right: 8px;
      margin-top: 8px;
      border-radius: 4px;
      &:hover {
        background-color: #fff;
      }
    }
  }
  .purchase-item__lots {
    padding: 0 16px 0 46px;
  }
  .collapse-enter-active,
  .collapse-leave-active {
    overflow: hidden;
  }
}
.purchase-item.collapsed {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  .collapse-button svg {
    transform: rotate(180deg);
  }
}
</style>
